var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
define(["require", "exports", "preact/jsx-runtime", "@os/os-communication-interface/lib/runtime/FrameworkPluginRuntime", "@os/os-components/lib/OsHooks/useTranslationFor", "preact/compat", "preact/hooks", "react-router-dom", "../alertMessage", "../common/errorPage", "../common/spinner", "../../contexts/helpProvider", "../../contexts/recentActivityProvider", "../../contexts/searchProvider", "../../contexts/userProvider", "../../hooks/useConfigOverride", "../../hooks/useMutation", "../../hooks/useQuery", "../../utils/analytics", "../../utils/chatbot", "../../utils/agent", "../../utils/environment", "../../utils/ogl", "../../utils/date", "../../utils/pluginContext", "./reducer", "./index.scss"], function (require, exports, jsx_runtime_1, FrameworkPluginRuntime_1, useTranslationFor_1, compat_1, hooks_1, react_router_dom_1, alertMessage_1, errorPage_1, spinner_1, helpProvider_1, recentActivityProvider_1, searchProvider_1, userProvider_1, useConfigOverride_1, useMutation_1, useQuery_1, analytics_1, chatbot_1, agent_1, environment_1, ogl_1, date_1, pluginContext_1, reducer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ErrorPageContent = exports.Content = void 0;
    const importHomePage = (environment) => (0, compat_1.lazy)(() => new Promise((resolve_1, reject_1) => { require([`./${environment}HomePage`], resolve_1, reject_1); }).then(__importStar));
    const nonce = crypto.randomUUID();
    const frameId = `pluginFrame-${nonce}`;
    const createFrame = (parentId, liftSandbox, isIframeScrollable) => {
        const body = document.getElementsByTagName("body")[0];
        if (isIframeScrollable) {
            body.classList.remove("oj-web-applayout-body");
        }
        else {
            body.classList.add("oj-web-applayout-body");
        }
        const parentNode = document.getElementById(parentId);
        if (parentNode) {
            const frame = document.createElement("iframe");
            frame.setAttribute("id", frameId);
            frame.setAttribute("scrolling", isIframeScrollable ? "" : "no");
            frame.setAttribute("frameborder", "0");
            frame.setAttribute("allow", "local-network");
            if (!liftSandbox) {
                frame.setAttribute("sandbox", "allow-forms allow-popups allow-popups-to-escape-sandbox allow-scripts allow-same-origin allow-downloads allow-modals");
                frame.setAttribute("allowfullscreen", "true");
            }
            frame.style.width = "100%";
            frame.style.minHeight = "100%";
            return parentNode.appendChild(frame);
        }
        return null;
    };
    const openPlugin = (url, pluginPath, allowedOrigins) => {
        (0, environment_1.debug)("[OCC] opening plugin", { url, pluginPath });
        const start = performance.now();
        return (0, FrameworkPluginRuntime_1.getPluginRuntime)().openPlugin({
            url,
            pluginPath,
            allowedOrigins,
            debug: environment_1.isDebugOn,
            embedded: {
                frameId
            }
        })
            .then(() => routePlugin(pluginPath, window.location.pathname))
            .catch(ex => {
            console.error("[OCC] Exception during opening plugin.", ex);
            throw ex;
        })
            .finally(() => {
            const end = performance.now();
            console.log(`[OCC] Openening plugin in ${end - start} ms.`);
        });
    };
    const routePlugin = (pluginPath, locationPath) => {
        var _a;
        const routeUrl = (_a = locationPath.split(pluginPath)[1]) !== null && _a !== void 0 ? _a : "";
        (0, FrameworkPluginRuntime_1.getPluginRuntime)().route(routeUrl);
    };
    const handleTopLevelAuthRedirect = (plugin) => {
        if (plugin === null || plugin === void 0 ? void 0 : plugin.authRedirectUrl) {
            const sessionRedirects = JSON.parse(sessionStorage.getItem("redirects") || "{}");
            if (!sessionRedirects[plugin.name]) {
                sessionRedirects[plugin.name] = true;
                sessionStorage.setItem("redirects", JSON.stringify(sessionRedirects));
                window.location.href = plugin.authRedirectUrl.replace("${url}", encodeURIComponent(window.location.href));
                return true;
            }
        }
        return false;
    };
    const Content = ({ plugin, finalPlugins, environment, accessToken, navigateRef, pluginRef, menuOpened, isError, handleNavigation, notificationItems, refreshNotifications }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const [{ plugin: pluginState, bootstrap, preFetch, isContentLoaded, windowHeight, pluginUnhandledException, error }, dispatch] = (0, hooks_1.useReducer)(reducer_1.reducer, reducer_1.initialState);
        const errorTitle = (0, useTranslationFor_1.useTranslationFor)("errorTitle");
        const errorMessage = (0, useTranslationFor_1.useTranslationFor)("errorMessage");
        // Plugin runtime init
        const { user, language, openLanguageSelector, refresh: userRefresh } = (0, hooks_1.useContext)(userProvider_1.UserContext);
        const accountId = (0, pluginContext_1.resolvePluginAccountId)(environment, (_b = (_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.defaultCompany) === null || _b === void 0 ? void 0 : _b.accountId);
        const custAccountId = (_d = (_c = user === null || user === void 0 ? void 0 : user.profile) === null || _c === void 0 ? void 0 : _c.defaultCompany) === null || _d === void 0 ? void 0 : _d.custAccountId;
        const role = (_f = (_e = user === null || user === void 0 ? void 0 : user.profile) === null || _e === void 0 ? void 0 : _e.defaultCompany) === null || _f === void 0 ? void 0 : _f.role;
        const { append: appendRecentActivity } = (0, hooks_1.useContext)(recentActivityProvider_1.RecentActivityContext);
        const { searchValue, setSearchValue } = (0, hooks_1.useContext)(searchProvider_1.SearchContext);
        const { refreshHelpContent, onContentSelected } = (0, hooks_1.useContext)(helpProvider_1.HelpContext);
        const addRecentActivity = (0, hooks_1.useCallback)(activity => {
            appendRecentActivity({
                plugin: plugin === null || plugin === void 0 ? void 0 : plugin.name,
                label: `recentActivity.${activity.label}`,
                entityId: activity.entityId,
                url: window.location.origin + activity.url,
                creationDate: new Date().toISOString(),
                entityAmount: activity.entityAmount,
                entityCurrency: activity.entityCurrency,
                entityDate: (0, date_1.normalizeLocalDateTime)(activity.entityDate)
            });
        }, [appendRecentActivity, plugin]);
        const navigate = (0, react_router_dom_1.useNavigate)();
        const navigationHandler = (0, hooks_1.useCallback)((url) => {
            const urlObj = new URL(url, window.location.origin);
            if (urlObj.origin !== window.location.origin) {
                handleNavigation({
                    labelKey: "",
                    path: urlObj.href
                })();
            }
            else {
                handleNavigation({
                    labelKey: "",
                    pluginName: "unknown",
                    appendPath: urlObj.href.replace(urlObj.origin, "")
                })();
                window.scrollTo({ top: 0, behavior: "smooth" });
                dispatch((0, reducer_1.setWindowHeight)(""));
            }
        }, [handleNavigation]);
        (0, hooks_1.useEffect)(() => {
            var _a;
            dispatch((0, reducer_1.setDisabledWccLanguages)(((_a = environment === null || environment === void 0 ? void 0 : environment.features) === null || _a === void 0 ? void 0 : _a.disabledWccLanguages) || []));
        }, [(_g = environment === null || environment === void 0 ? void 0 : environment.features) === null || _g === void 0 ? void 0 : _g.disabledWccLanguages]);
        (0, hooks_1.useEffect)(() => {
            if (navigate) {
                navigateRef(navigate);
            }
            if (navigate && addRecentActivity && navigationHandler && (accessToken || (0, environment_1.isPublicZone)(environment))) {
                (0, environment_1.debug)("[OCC] useEffect - plugin runtime init");
                (0, FrameworkPluginRuntime_1.getPluginRuntime)().init({
                    initialContext: {
                        accessToken, searchText: searchValue, frameworkPlugins: finalPlugins, language,
                        accountId, custAccountId, notificationItems, role
                    },
                    messageHandlers: {
                        navigate: navigationHandler,
                        setHeight: windowHeight => { var _a; return dispatch((0, reducer_1.setWindowHeight)(((_a = plugin.options) === null || _a === void 0 ? void 0 : _a.isIframeScrollable) ? "unset" : windowHeight)); },
                        addRecentActivity: addRecentActivity,
                        trackAnalytics: analytics_1.trackAnalytics,
                        pluginUnhandledException: exception => dispatch((0, reducer_1.setPluginUnhandledException)(exception)),
                        handleChangeLanguageRequest: () => openLanguageSelector(true),
                        pluginDialogOpenedFunc: options => {
                            var _a, _b, _c, _d, _e, _f, _g;
                            (0, ogl_1.showOgl)(((_b = (_a = plugin.options) === null || _a === void 0 ? void 0 : _a.isOglEnabled) !== null && _b !== void 0 ? _b : true) && !options.opened);
                            if ((_c = environment.features.agentChatBot) === null || _c === void 0 ? void 0 : _c.channelId) {
                                (0, agent_1.showAiAgent)(((_e = (_d = plugin.options) === null || _d === void 0 ? void 0 : _d.isChatbotEnabled) !== null && _e !== void 0 ? _e : true) && !options.opened);
                            }
                            else {
                                (0, chatbot_1.showChatbot)(((_g = (_f = plugin.options) === null || _f === void 0 ? void 0 : _f.isChatbotEnabled) !== null && _g !== void 0 ? _g : true) && !options.opened);
                            }
                        },
                        refreshService: service => {
                            (0, environment_1.debug)("[OCC] refresh service request received", service);
                            if (service === "user") {
                                userRefresh();
                            }
                            else if (service === "notification") {
                                refreshNotifications();
                            }
                        },
                        selectAccount: () => {
                            window.dispatchEvent(new CustomEvent("occ:switch-company:select-account-request"));
                        },
                        hideAccount: () => {
                            window.dispatchEvent(new CustomEvent("occ:switch-company:hide-account-request"));
                        }
                    },
                    options: { keepAliveOnClose: true }
                });
            }
        }, [navigate, addRecentActivity, navigationHandler, accessToken]);
        // Change plugin
        (0, hooks_1.useEffect)(() => {
            var _a;
            (0, environment_1.debug)("[OCC] useEffect - change plugin", JSON.stringify({ plugin }));
            if (!handleTopLevelAuthRedirect(plugin)) {
                dispatch((0, reducer_1.setPlugin)(plugin));
                onContentSelected === null || onContentSelected === void 0 ? void 0 : onContentSelected(undefined);
                refreshHelpContent === null || refreshHelpContent === void 0 ? void 0 : refreshHelpContent((_a = plugin === null || plugin === void 0 ? void 0 : plugin.options) === null || _a === void 0 ? void 0 : _a.helpTopicId);
                if (environment === null || environment === void 0 ? void 0 : environment.botChannelId) {
                    (0, chatbot_1.refreshChatbotDragAndDrop)();
                }
            }
        }, [plugin]);
        // Substitute plugin url
        const params = (0, react_router_dom_1.useParams)();
        (0, hooks_1.useEffect)(() => {
            if (params && (pluginState === null || pluginState === void 0 ? void 0 : pluginState.substituteUrl)) {
                (0, environment_1.debug)("[OCC] useEffect - substitute plugin url", JSON.stringify({ params, pluginStateSubstituteUrl: pluginState.substituteUrl }));
                const { "*": splatParam } = params, nonSplatParams = __rest(params, ["*"]);
                let substitutedUrl = pluginState.substituteUrl;
                if (Object.keys(nonSplatParams).length > 0) {
                    substitutedUrl = Object.keys(nonSplatParams).reduce((acc, curr) => acc.replace(`:${curr}`, nonSplatParams[curr]), plugin.url);
                }
                if (substitutedUrl === null || substitutedUrl === void 0 ? void 0 : substitutedUrl.includes("/*")) {
                    substitutedUrl = substitutedUrl.replace("/*", `/${splatParam}`);
                }
                dispatch((0, reducer_1.setPluginUrl)(substitutedUrl));
            }
            if (params && (preFetch === null || preFetch === void 0 ? void 0 : preFetch.substituteUrl)) {
                (0, environment_1.debug)("[OCC] useEffect - substitute prefetch url", JSON.stringify({ params, preFetchSubstituteUrl: preFetch.substituteUrl }));
                const { "*": splatParam } = params, nonSplatParams = __rest(params, ["*"]);
                let substitutedUrl = preFetch.substituteUrl;
                if (Object.keys(nonSplatParams).length > 0) {
                    substitutedUrl = Object.keys(nonSplatParams).reduce((acc, curr) => acc.replace(`:${curr}`, nonSplatParams[curr]), plugin.url);
                }
                if (substitutedUrl === null || substitutedUrl === void 0 ? void 0 : substitutedUrl.includes("/*")) {
                    substitutedUrl = substitutedUrl.replace("/*", `/${splatParam}`);
                }
                dispatch((0, reducer_1.setPreFetchUrl)(substitutedUrl));
            }
        }, [params, pluginState === null || pluginState === void 0 ? void 0 : pluginState.substituteUrl, preFetch === null || preFetch === void 0 ? void 0 : preFetch.substituteUrl]);
        // Bootstrap plugin
        const { invoke: invokeBoostrap, result: { error: bootstrapError } } = (0, useMutation_1.useBootstrapMutation)(plugin === null || plugin === void 0 ? void 0 : plugin.bootstrapUrl, accessToken);
        (0, hooks_1.useEffect)(() => {
            if (bootstrap.url && bootstrap.params) {
                (0, environment_1.debug)("[OCC] useEffect - bootstrap", JSON.stringify({ bootstrap }));
                (0, environment_1.debug)("[OCC] bootstrap request sent.", bootstrap);
                invokeBoostrap(bootstrap.params, resp => {
                    (0, environment_1.debug)("[OCC] bootstrap response received.", resp);
                    dispatch((0, reducer_1.setPluginUrl)(resp.bootstrapUrl));
                });
            }
        }, [bootstrap]);
        // Prefetch plugin
        const { result: preFetchResult, error: preFetchError, loading: preFetchLoading } = (0, useQuery_1.usePreFetchQuery)(preFetch.url, accessToken);
        (0, hooks_1.useEffect)(() => {
            if (preFetchResult) {
                (0, environment_1.debug)("[OCC] useEffect - preFetchResult", JSON.stringify({ preFetchResult }));
                (0, environment_1.debug)("[OCC] prefetch succeeded.");
                if (preFetchResult.type === "application/pdf") {
                    dispatch((0, reducer_1.setPluginLiftSandbox)(true));
                }
                dispatch((0, reducer_1.setPluginUrl)(URL.createObjectURL(preFetchResult)));
            }
        }, [preFetchResult]);
        // Open plugin
        (0, hooks_1.useEffect)(() => {
            var _a, _b;
            if (pluginState.url) {
                (0, environment_1.debug)("[OCC] useEffect - open plugin", JSON.stringify({ pluginState }));
                const pluginFrame = createFrame("content", (_a = pluginState.options) === null || _a === void 0 ? void 0 : _a.liftSandbox, (_b = pluginState.options) === null || _b === void 0 ? void 0 : _b.isIframeScrollable);
                openPlugin(pluginState.url, pluginState.path, pluginState.allowedOrigins)
                    .finally(() => dispatch((0, reducer_1.setContentLoaded)()));
                return () => {
                    var _a;
                    (0, environment_1.debug)("[OCC] disposing plugin");
                    if ((_a = pluginState.options) === null || _a === void 0 ? void 0 : _a.liftSandbox) {
                        dispatch((0, reducer_1.setPluginLiftSandbox)(false));
                    }
                    pluginFrame === null || pluginFrame === void 0 ? void 0 : pluginFrame.remove();
                    setSearchValue(undefined);
                    (0, FrameworkPluginRuntime_1.getPluginRuntime)().disposeService();
                };
            }
        }, [pluginState === null || pluginState === void 0 ? void 0 : pluginState.url]);
        // Runtime context
        (0, hooks_1.useEffect)(() => {
            (0, environment_1.debug)("[OCC] useEffect - runtime context change", JSON.stringify(Object.assign({ language, isContentLoaded, accountId }, role)));
            dispatch((0, reducer_1.setLanguage)(language));
            if (isContentLoaded) {
                (0, FrameworkPluginRuntime_1.getPluginRuntime)().updateRuntimeContext({ language, accountId, searchText: searchValue, custAccountId, notificationItems, role });
                // 'setLanguage' call can be removed when plugins uptake the new communication version
                (0, FrameworkPluginRuntime_1.getPluginRuntime)().setLanguage(language);
            }
        }, [language, accountId, custAccountId, searchValue, notificationItems, isContentLoaded, role]);
        // Location change
        const location = (0, react_router_dom_1.useLocation)();
        (0, hooks_1.useEffect)(() => {
            var _a;
            if (plugin) {
                if ((plugin === null || plugin === void 0 ? void 0 : plugin.name) === pluginState.name && ((_a = plugin === null || plugin === void 0 ? void 0 : plugin.url) === null || _a === void 0 ? void 0 : _a.includes("/*")) && location.pathname.startsWith(pluginState.path)) {
                    (0, environment_1.debug)("[OCC] useEffect - location change for splat plugin config", JSON.stringify({ location, plugin }));
                    dispatch((0, reducer_1.setPlugin)(plugin));
                }
                else {
                    (0, environment_1.debug)("[OCC] useEffect - location change", JSON.stringify({ location, plugin }));
                    routePlugin(plugin.path, location.pathname);
                }
                window.dispatchEvent(new CustomEvent("occ:navigation"));
                pluginRef(plugin);
            }
        }, [plugin, location.pathname]);
        (0, hooks_1.useEffect)(() => {
            var _a;
            if (pluginState.path === location.pathname || (plugin === null || plugin === void 0 ? void 0 : plugin.name) === pluginState.name && ((_a = plugin === null || plugin === void 0 ? void 0 : plugin.url) === null || _a === void 0 ? void 0 : _a.includes("/*")) && location.pathname.startsWith(pluginState.path)) {
                (0, environment_1.debug)("[OCC] useEffect - location search params change", JSON.stringify({ location, plugin, pluginState }));
                // seems like only location search is changed, the plugin remained the same, but we have to start all over again
                dispatch((0, reducer_1.setPlugin)(plugin));
            }
        }, [location.search]);
        // Error
        (0, hooks_1.useEffect)(() => {
            if (isError || bootstrapError || preFetchError) {
                (0, environment_1.debug)("[OCC] useEffect - error", JSON.stringify({ isError, bootstrapError, preFetchError }));
                dispatch((0, reducer_1.setError)(isError ? "invalidRoute" : "fatal"));
                dispatch((0, reducer_1.setContentLoaded)());
            }
        }, [isError, bootstrapError, preFetchError]);
        const configOverride = (0, useConfigOverride_1.useConfigOverride)();
        const showLabel = (0, hooks_1.useMemo)(() => {
            var _a, _b;
            return (_b = (_a = configOverride.plugins) === null || _a === void 0 ? void 0 : _a.some(p => p.name === (plugin === null || plugin === void 0 ? void 0 : plugin.name))) !== null && _b !== void 0 ? _b : false;
        }, [configOverride, plugin]);
        const HomePage = importHomePage(environment.name);
        return ((0, jsx_runtime_1.jsxs)("div", { id: "content", className: `oj-flex-item oj-flex ${showLabel ? "override-border" : "no-border"}`, style: { width: "100%", minHeight: windowHeight }, children: [pluginUnhandledException &&
                    (0, jsx_runtime_1.jsx)(alertMessage_1.AlertMessage, { message: errorTitle, details: errorMessage }), plugin &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showLabel && (0, jsx_runtime_1.jsx)("div", { className: "override-label", children: (_j = (_h = configOverride.plugins) === null || _h === void 0 ? void 0 : _h.filter(p => p.name === (plugin === null || plugin === void 0 ? void 0 : plugin.name))[0]) === null || _j === void 0 ? void 0 : _j.url }), menuOpened && (0, jsx_runtime_1.jsx)("div", { className: "oj-component-overlay" }), preFetchLoading && (0, jsx_runtime_1.jsx)(spinner_1.Spinner, {})] }), !plugin && !error &&
                    (0, jsx_runtime_1.jsx)(compat_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(spinner_1.Spinner, {}), children: (0, jsx_runtime_1.jsx)(HomePage, { environment: environment }) }), error &&
                    (0, jsx_runtime_1.jsx)(errorPage_1.ErrorPage, { errorType: error.type, environment: environment })] }));
    };
    exports.Content = Content;
    const ErrorPageContent = ({ environment, navigateRef, menuOpened, handleNavigation }) => {
        return ((0, jsx_runtime_1.jsx)(exports.Content, { plugin: undefined, finalPlugins: undefined, environment: environment, accessToken: undefined, navigateRef: navigateRef, pluginRef: (_) => { }, menuOpened: menuOpened, isError: true, handleNavigation: handleNavigation, notificationItems: [], refreshNotifications: () => { } }));
    };
    exports.ErrorPageContent = ErrorPageContent;
});
